module.exports = __webpack_public_path__ + "static/img/25.8a8ed8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/25.png
// module id = lf3h
// module chunks = 0